import { ref } from "vue";

const showUpdateBanner = ref(false);
const activeVersion = ref(import.meta.env.VITE_APP_VERSION);

export function useAppVersion() {
  async function getLatestAppVersion(): Promise<string> {
    const response = await fetch("/version.txt", { cache: "no-store" }).catch((error) => {
      console.error(error);
      return;
    });
    if (!response?.ok) {
      console.error("HTTP Error: ", response?.status);
      return "";
    }
    return await response.text();
  }

  async function checkForNewerVersion(): Promise<void> {
    const currentVersion = await getLatestAppVersion();
    if (activeVersion.value < currentVersion && currentVersion.length) {
      showUpdateBanner.value = true;
    }
  }

  return {
    showUpdateBanner,
    activeVersion,
    getLatestAppVersion,
    checkForNewerVersion,
  };
}
